import React, { useEffect, useState } from 'react'
import LoadSpinner from '../../../components/load-spinner/LoadSpinner';
import { useNavigate } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import CustomTable from '../../../components/custom-table/CustomTable';
import { faMagnifyingGlass, faPlus } from '@fortawesome/free-solid-svg-icons';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import useTag from '../../../hooks/useTag';
import { toast } from 'react-toastify';
import { setSelectedTag, setShowEditTagDoorModal } from '../../../slice/editTagSlice';
import CreateDoorTag from '../../../components/modals/create-door-tag/CreateDoorTag';
import { setShowCreateTagDoorModal } from '../../../slice/showModalSlice';
import EditDoorTag from '../../../components/modals/edit-door-tag/EditDoorTag';
import { privileges } from '../../../config/role';

const DashboardDoorTags = () => {
    // const { getLabel } = useLabel()
    const [labels,setLabels] = useState([]);

    const dispatch = useDispatch();
    const showCreateModal = useSelector((state)=>state.showModal.showCreateTagDoorModal);
    const userRole = useSelector((state)=> state.user.role);
    const authorized = privileges.editingDoorTags.includes(userRole);
    const { getDoorTags, tagLoading } = useTag();

    useEffect(()=>{
        getLabelsData();
    },[])

    const getLabelsData = () => {
      getDoorTags(
        (data)=>{
            setLabels(data.content)
        },
        ()=>{
          toast.error("Errore nel ricevere i tag porte")
        },
        false
      )
    }


    const headerTable = [
        { label: "Nome", field: "name", width: 270 },
        { label: "Tipo", field: "type", width: 270 },
        { label: "Colore", field: "palette", width: 270 },
    ];

  const dataForTable = (labels || []).map((label) => ({
    ...label,
    clickEvent: () => {
      dispatch(setSelectedTag(label));
      dispatch(setShowEditTagDoorModal())
    },
    palette: <div className='ms-auto me-auto' style={{backgroundColor:`${label.color}`,width:"25px", height:"25px", borderRadius:"50%"}}></div>
  }));

  const createNewTag = () => {
    dispatch(setShowCreateTagDoorModal());
  }


  return (
    <>
      <div className="container-fluid">
        <div className='row px-3'>
          <div className="d-flex align-items-center justify-content-between mb-4 px-1">
            <h1 className="h1 mb-2 text-primary-custom">Dashboard Uffici</h1>
             {authorized &&<Button className='btn-custom btn-green' onClick={createNewTag}>
              <FontAwesomeIcon icon={faPlus}/> Aggiungi
            </Button>}
          </div>
        </div>
        <div className="row mb-3">
          {tagLoading
          ?<LoadSpinner/>
          :<CustomTable
            clickIcon={faMagnifyingGlass}
            header={headerTable}
            data={dataForTable}
            checkable={false}
            label='Uffici'/>
          }
        </div>
      </div>
      {showCreateModal && <CreateDoorTag onSuccess={getLabelsData}/>}
      <EditDoorTag onSuccess={getLabelsData}/>
    </>
  );
}

export default DashboardDoorTags